import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_5 = ["selected"]
const _hoisted_6 = ["value", "selected"]
const _hoisted_7 = { class: "d-flex align-items-center position-relative ms-5" }
const _hoisted_8 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = ["selected"]
const _hoisted_11 = ["selected"]
const _hoisted_12 = ["selected"]
const _hoisted_13 = ["selected"]
const _hoisted_14 = ["selected"]
const _hoisted_15 = ["selected"]
const _hoisted_16 = ["selected"]
const _hoisted_17 = ["selected"]
const _hoisted_18 = ["selected"]
const _hoisted_19 = ["selected"]
const _hoisted_20 = ["selected"]
const _hoisted_21 = { class: "card-body pt-0" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-fw fa-phone-square" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-fw fa-envelope" }, null, -1)
const _hoisted_27 = {
  key: 0,
  class: "badge badge-light-primary"
}
const _hoisted_28 = {
  key: 1,
  class: "badge badge-light-success"
}
const _hoisted_29 = {
  key: 0,
  class: "badge badge-light-warning"
}
const _hoisted_30 = {
  key: 1,
  class: "badge badge-light-primary"
}
const _hoisted_31 = {
  key: 2,
  class: "badge badge-light-primary"
}
const _hoisted_32 = {
  key: 3,
  class: "badge badge-light-info"
}
const _hoisted_33 = {
  key: 4,
  class: "badge badge-light-info"
}
const _hoisted_34 = {
  key: 5,
  class: "badge badge-light-success"
}
const _hoisted_35 = {
  key: 6,
  class: "badge badge-light-danger"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-plus-circle fa-fw" }, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-pen fa-fw" }, null, -1)
const _hoisted_39 = {
  href: "#",
  class: "btn btn-sm btn-light btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_40 = { class: "svg-icon svg-icon-5 m-0" }
const _hoisted_41 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-auto py-4",
  "data-kt-menu": "true"
}
const _hoisted_42 = { class: "menu-item px-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _directive_debounce = _resolveDirective("debounce")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("select", {
            class: "form-select form-select-solid w-auto",
            "aria-label": "Select Branch",
            onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onBranchChange($event)))
          }, [
            _createElementVNode("option", {
              value: "",
              selected: _ctx.branchId === 0
            }, _toDisplayString(_ctx.I18nUtils.translate("sea.pages.orders.selectTextBranchAll")), 9, _hoisted_5),
            (_ctx.branchesRef && _ctx.branchesRef.length > 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.branchesRef, (branch) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: branch.id,
                    value: branch.id,
                    selected: _ctx.branchId === branch.id
                  }, _toDisplayString(branch.name), 9, _hoisted_6))
                }), 128))
              : _createCommentVNode("", true)
          ], 32),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen021.svg" })
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event)),
              class: "form-control form-control-solid w-200px ps-15",
              placeholder: 
                _ctx.I18nUtils.translate('sea.pages.orders.searchHintCustomer')
              
            }, null, 8, _hoisted_9), [
              [_vModelText, _ctx.name],
              [_directive_debounce, _ctx.getData, "500ms"]
            ])
          ]),
          _createElementVNode("select", {
            class: "form-select form-select-solid w-auto ms-5",
            "aria-label": "Select Branch",
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onTypeChange($event)))
          }, [
            _createElementVNode("option", {
              value: "",
              selected: _ctx.type === 0
            }, _toDisplayString(_ctx.I18nUtils.translate("sea.pages.orders.selectTextTypeAll")), 9, _hoisted_10),
            _createElementVNode("option", {
              value: "1",
              selected: _ctx.type === 1
            }, _toDisplayString(_ctx.I18nUtils.translate("sea.pages.orders.selectTextTypePickUp")), 9, _hoisted_11),
            _createElementVNode("option", {
              value: "2",
              selected: _ctx.type === 2
            }, _toDisplayString(_ctx.I18nUtils.translate("sea.pages.orders.selectTextTypeDelivery")), 9, _hoisted_12)
          ], 32),
          _createElementVNode("select", {
            class: "form-select form-select-solid w-auto ms-5",
            "aria-label": "Select Branch",
            onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onStatusChange($event)))
          }, [
            _createElementVNode("option", {
              value: "",
              selected: _ctx.status === 0
            }, _toDisplayString(_ctx.I18nUtils.translate("sea.pages.orders.selectTextStatusAll")), 9, _hoisted_13),
            _createElementVNode("option", {
              value: "1",
              selected: _ctx.status === 1
            }, _toDisplayString(_ctx.I18nUtils.translate("sea.pages.orders.selectTextStatusPending")), 9, _hoisted_14),
            _createElementVNode("option", {
              value: "2",
              selected: _ctx.status === 2
            }, _toDisplayString(_ctx.I18nUtils.translate(
                  "sea.pages.orders.selectTextStatusProcessing"
                )), 9, _hoisted_15),
            _createElementVNode("option", {
              value: "3",
              selected: _ctx.status === 3
            }, _toDisplayString(_ctx.I18nUtils.translate(
                  "sea.pages.orders.selectTextStatusProcessed"
                )), 9, _hoisted_16),
            _createElementVNode("option", {
              value: "4",
              selected: _ctx.status === 4
            }, _toDisplayString(_ctx.I18nUtils.translate("sea.pages.orders.selectTextStatusReady")), 9, _hoisted_17),
            _createElementVNode("option", {
              value: "5",
              selected: _ctx.status === 5
            }, _toDisplayString(_ctx.I18nUtils.translate("sea.pages.orders.selectTextStatusShipping")), 9, _hoisted_18),
            _createElementVNode("option", {
              value: "6",
              selected: _ctx.status === 6
            }, _toDisplayString(_ctx.I18nUtils.translate(
                  "sea.pages.orders.selectTextStatusCompleted"
                )), 9, _hoisted_19),
            _createElementVNode("option", {
              value: "7",
              selected: _ctx.status === 7
            }, _toDisplayString(_ctx.I18nUtils.translate(
                  "sea.pages.orders.selectTextStatusCancelled"
                )), 9, _hoisted_20)
          ], 32)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createVNode(_component_Datatable, {
        loading: _ctx.loading,
        "table-headers": _ctx.tableHeaders,
        data: _ctx.ordersRef,
        total: _ctx.ordersTotalRef,
        "page-number": _ctx.ordersPageNumberRef,
        "page-size": _ctx.ordersPageSizeRef,
        onPageSizeChange: _ctx.updatePageSize,
        onPageNumberChange: _ctx.updatePageNumber,
        onSort: _ctx.sortOrders
      }, {
        "cell-id": _withCtx(({ row: order }) => [
          _createElementVNode("strong", null, _toDisplayString(order.id), 1)
        ]),
        "cell-orderNumber": _withCtx(({ row: order }) => [
          _createElementVNode("strong", null, _toDisplayString(order.orderNumber), 1)
        ]),
        "cell-branch": _withCtx(({ row: order }) => [
          (order.branch)
            ? (_openBlock(), _createElementBlock("strong", _hoisted_22, _toDisplayString(order.branch.name), 1))
            : _createCommentVNode("", true)
        ]),
        "cell-price": _withCtx(({ row: order }) => [
          (order.total)
            ? (_openBlock(), _createElementBlock("strong", _hoisted_23, " $" + _toDisplayString(parseFloat(order.total).toFixed(2)), 1))
            : _createCommentVNode("", true)
        ]),
        "cell-name": _withCtx(({ row: order }) => [
          _createElementVNode("strong", null, _toDisplayString(order.name), 1)
        ]),
        "cell-contact": _withCtx(({ row: order }) => [
          _createElementVNode("strong", null, [
            _hoisted_24,
            _createTextVNode(" " + _toDisplayString(order.telephone), 1)
          ]),
          (order.email)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_25,
                _createElementVNode("strong", null, [
                  _hoisted_26,
                  _createTextVNode(" " + _toDisplayString(order.email), 1)
                ])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        "cell-type": _withCtx(({ row: order }) => [
          (order.type === 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.I18nUtils.translate("sea.pages.orders.badgeTextTypePickUp")), 1))
            : _createCommentVNode("", true),
          (order.type === 2)
            ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.I18nUtils.translate("sea.pages.orders.badgeTextTypeDelivery")), 1))
            : _createCommentVNode("", true)
        ]),
        "cell-status": _withCtx(({ row: order }) => [
          (order.status === 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.I18nUtils.translate("sea.pages.orders.badgeTextStatusPending")), 1))
            : _createCommentVNode("", true),
          (order.status === 2)
            ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.I18nUtils.translate("sea.pages.orders.badgeTextStatusProcessing")), 1))
            : _createCommentVNode("", true),
          (order.status === 3)
            ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.I18nUtils.translate("sea.pages.orders.badgeTextStatusProcessed")), 1))
            : _createCommentVNode("", true),
          (order.status === 4)
            ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.I18nUtils.translate("sea.pages.orders.badgeTextStatusReady")), 1))
            : _createCommentVNode("", true),
          (order.status === 5)
            ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.I18nUtils.translate("sea.pages.orders.badgeTextStatusShipping")), 1))
            : _createCommentVNode("", true),
          (order.status === 6)
            ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_ctx.I18nUtils.translate("sea.pages.orders.badgeTextStatusCompleted")), 1))
            : _createCommentVNode("", true),
          (order.status === 7)
            ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.I18nUtils.translate("sea.pages.orders.badgeTextStatusCancelled")), 1))
            : _createCommentVNode("", true)
        ]),
        "cell-date": _withCtx(({ row: product }) => [
          _hoisted_36,
          _createTextVNode(" " + _toDisplayString(_ctx.DateTimeUtils.parseDateTime(product.createdAt)) + " ", 1),
          (product.modifiedAt)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_37,
                _hoisted_38,
                _createTextVNode(" " + _toDisplayString(_ctx.DateTimeUtils.parseDateTime(product.modifiedAt)), 1)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        "cell-actions": _withCtx(({ row: order }) => [
          _createElementVNode("a", _hoisted_39, [
            _createTextVNode(_toDisplayString(_ctx.I18nUtils.translate("sea.pages.orders.buttonActions")) + " ", 1),
            _createElementVNode("span", _hoisted_40, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr072.svg" })
            ])
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createVNode(_component_router_link, {
                to: {
                  name: 'order',
                  params: { id: order.id },
                },
                class: "menu-link px-3"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.I18nUtils.translate("sea.pages.orders.buttonView")), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["loading", "table-headers", "data", "total", "page-number", "page-size", "onPageSizeChange", "onPageNumberChange", "onSort"])
    ])
  ]))
}